import { gql } from '@apollo/client';

import { BANK_DATA_PROVIDER_INSTITUTION_FIELDS } from './fragments.gql';

export const EXCHANGE_PLAID_PUBLIC_TOKEN = gql`
  ${BANK_DATA_PROVIDER_INSTITUTION_FIELDS}
  mutation ConnectPlaidItem(
    $publicToken: String!
    $plaidInstitutionId: String!
  ) {
    connectPlaidItem(
      publicToken: $publicToken
      plaidInstitutionId: $plaidInstitutionId
    ) {
      ...BankDataProviderInstitutionFields
    }
  }
`;

export const REFRESH_PLAID_INSTITUTION_ACCOUNTS = gql`
  mutation RefreshPlaidInstitutionAccounts($plaidItemId: UUID!) {
    refreshPlaidInstitutionAccounts(plaidItemId: $plaidItemId) {
      ...BankDataProviderInstitutionFields
    }
  }
`;

export const INVALIDATE_PLAID_ITEM = gql`
  mutation InvalidatePlaidItem($plaidItemId: UUID!) {
    disconnectPlaidItem(plaidItemId: $plaidItemId) {
      plaidResponse
    }
  }
`;

export const RECONNECT_PLAID_ITEM = gql`
  mutation ReconnectPlaidItem($plaidItemId: UUID!) {
    reconnectPlaidItem(plaidItemId: $plaidItemId) {
      plaidResponse
    }
  }
`;

export const GET_PLAID_LINK_TOKEN = gql`
  query GetPlaidLinkToken {
    plaidLinkToken {
      token
      needsUpdate
      institutionName
      plaidItemId
    }
  }
`;

export const GET_ALL_PLAID_INSTITUTION_ACCOUNTS = gql`
  ${BANK_DATA_PROVIDER_INSTITUTION_FIELDS}
  query GetAllPlaidInstitutionAccounts {
    allPlaidInstitutionAccounts {
      ...BankDataProviderInstitutionFields
    }
  }
`;
